import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import styles from '../header.module.css'
import logo from '../../../../assets/images/logo.png'
import SupportIcon from '../../../../assets/images/icon/SupportIcons.svg'
import ShareIcon from '../../../../assets/images/icon/shareicon.svg'
import constant from '../../../../constant'
import { removeAllSessionStorage } from '../../../../utils'

const JobHeader = () => {
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['jobheader-box']}`}>
                        <div className={`${styles['jobheader-list']}`}>
                            <Link to={constant.component.dashboard.url} onClick={() => { removeAllSessionStorage() }}><img src={ShareIcon} alt="ShareIcon" className='pe-2' />Back to Home</Link>
                        </div>
                        <div className="navbar-brand logo">
                            <Link to='/'><img src={logo} alt="logo" /></Link>
                        </div>
                        <div className={`${styles['jobheader-list']}`}>
                            <a target='_blank' href="https://api.whatsapp.com/send/?phone=+917353466466&text=Need+help+in+job+posting.&type=phone_number&app_absent=0"><img src={SupportIcon} alt="ShareIcon" className='pe-2' />Get instant Support</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobHeader